<div
  class="row align-items-start"
  [style.background]="backgroundColor"
  [style.color]="isDarkTheme ? 'rgba(37, 43, 54, 0.95) !important' : null"
>
  <div [ngClass]="imageUrl || loading ? 'col-md-6' : 'col-md-12'">
    <div class="preview-content">
      <div class="preview-header">
        <div [innerHTML]="safeAgradecimiento"></div>
      </div>

      <div class="credential-box">
        <div class="credential-content" [innerHTML]="safeShareText"></div>
      </div>

      <div class="preview-actions">
        <button
          cButton
          [style.background-color]="buttonColors.copy"
          [style.border-color]="buttonColors.copy"
          [disabled]="previewMode"
          (click)="copy.emit()"
        >
          <svg [cIcon]="icons.cilCopy" class="me-2"></svg>
          <span>Copiar texto</span>
        </button>

        <button
          cButton
          [style.background-color]="buttonColors.share"
          [style.border-color]="buttonColors.share"
          [disabled]="previewMode || loading"
          (click)="share.emit()"
        >
          <svg [cIcon]="icons.cilShareAlt" class="me-2"></svg>
          <span>Compartir</span>
        </button>

        <button
          cButton
          [style.background-color]="buttonColors.download"
          [style.border-color]="buttonColors.download"
          [disabled]="previewMode || downloading || loading"
          (click)="download.emit()"
        >
          <svg [cIcon]="icons.cilCloudDownload" class="me-2"></svg>
          <span>{{ downloading ? "Descargando..." : "Descargar" }}</span>
        </button>

        <span
          [style.color]="textColorInstructivo"
          class="text-instruction-preview"
        >
          *Al presionar este botón, la credencial se descargará en tu carpeta de
          archivos. Para guardarla en tu galería, mantén presionada la
          credencial durante unos segundos y aparecerá la opción para guardarla
          en tu galería de fotos.
        </span>

        <button
          cButton
          [style.background-color]="buttonColors.back"
          [style.border-color]="buttonColors.back"
          [disabled]="previewMode"
          (click)="back.emit()"
        >
          <svg [cIcon]="icons.cilArrowLeft" class="me-2"></svg>
          <span>Volver</span>
        </button>
      </div>
    </div>
  </div>

  @if (imageUrl || loading) {
    <div class="col-md-6 text-center mt-4 mt-md-0 credential-image-col">
      <div class="credential-image-wrapper">
        @if (!imageLoaded || loading) {
          <div class="credential-skeleton" aria-hidden="true">
            <div class="credential-skeleton__header"></div>
            <div class="credential-skeleton__avatar"></div>
            <div
              class="credential-skeleton__line credential-skeleton__line--title"
            ></div>
            <div
              class="credential-skeleton__line credential-skeleton__line--subtitle"
            ></div>
            <div class="credential-skeleton__footer"></div>
          </div>
        }

        @if (imageUrl) {
          <img
            #credentialImg
            class="img-credential"
            [class.img-credential--loaded]="imageLoaded && !loading"
            [src]="imageUrl"
            alt="Credencial generada"
            decoding="async"
            crossorigin="anonymous"
            (load)="onImageLoad()"
            (error)="onImageError()"
          />
        }
      </div>
    </div>
  }
</div>
